import {IAnnouncement} from './getAnnounceList'
import {ApiRes} from '../../types/api'
import {API_URL, apiGet} from '../api'

export const getAnnounceDetail = async (id: string): Promise<ApiRes<IAnnouncement>> => {
    return await apiGet(API_URL, `official/post/${id}`)
}
